import { FC, useState, useEffect } from "react";
import * as M from "moment";
import { observer } from "mobx-react-lite";
import { IButton, ICheckbox, DraggableModal } from "../../ui-kit";
import { ITab, ITabs } from "../../ui-kit/Tabs/Tabs";
import AgreementDefectData from "./data/agreement";
import AllDefectData from "./data/all";
import PlannedDefectData from "./data/planned";
import AgreementPlanedDefectData from "./data/agreementPlaned";
import DefectCard from "./data/card";
import DefectActions from "./actions";
import DefectTableSettingsForm from "./common/table_settings";
import DefectFilter from "./filter";

import DefectTableFields from "../../store/defectTableFields";
import defectCardsStore from "../../store/defectCards";
import userSettingsStore from "../../store/userSettings";
import { authStore } from "../../store/authStore";

import {
  CloseMediumIco,
  SettingsIco,
  DropDownWithoutSpaceIco,
} from "../../assets/customIcons";
import Constants from "../../constants/Common";

import styles from "./Defect.module.scss";
import allDefectDataStore from "../../store/allDefectData";
import agreementPlanedDefectDataStore from "../../store/agreementPlanedDefectData";
import plannedDefectDataStore from "../../store/plannedDefectData";
import agreementDefectDataStore from "../../store/agreementDefectData";
import { useHistory, useParams } from "react-router-dom";
import { useStatusMessage } from "../../hooks/useStatusMessage";
import DefectNotifyPopup from "./data/defectNotifyPopup";
import {
  AGREED_PLANNED,
  CONSISTENT_DEFECTS,
  REGISTER_DEFECTS,
  REGISTER_PLANNED,
  SETTINGS_DEFECT_KEY,
  SETTINGS_PLAN_KEY,
} from "./constants";

// TODO onFinish функционал больше не нужен, в будущем очистить код, там где вызывается DefectValidator
interface DefectValidatorProps {
  onFinish?: () => void;
}

export interface IDefectDataProps {
  columns?: DefectTableFields;
  openDefectCard?: (id: string) => void;
  id?: string;
}

export const DEFAULT_DEFECT_COLS: Array<any> = [
  {
    title: "№ п/п",
    dataIndex: "id",
    key: "id",
    width: "100px",
    sortable: true,
    fixed: true,
    visible: true,
  },
  {
    title: "ID дефекта",
    dataIndex: "externalId",
    key: "externalId",
    sortable: true,
    visible: true,
  },
  {
    title: "GUID",
    dataIndex: "uniqueIdentifier",
    key: "uniqueIdentifier",
    render: (uniqueIdentifier) => {
      return uniqueIdentifier ? uniqueIdentifier : "-";
    },
    sortable: true,
    visible: false,
  },
  {
    title: "Статус",
    dataIndex: ["incidentStatus", "title"],
    key: "incidentStatus",
    sortable: true,
    visible: true,
  },
  {
    title: "Организация",
    dataIndex: ["organization", "name"],
    key: "organization",
    className: "align-left",
    sortable: true,
    visible: true,
  },
  {
    title: "Адрес дефекта",
    dataIndex: "addressText",
    key: "addressText",
    className: "align-left",
    sortable: true,
    visible: true,
  },
  {
    title: "Дата отключения/ограничения",
    dataIndex: "dateTimeDisable",
    key: "dateTimeDisable",
    className: "nowrap",
    render: (date: Date) =>
      date ? M(date).format(Constants.dateFormat) : Constants.notSet,
    sortable: true,
    visible: true,
  },
  {
    title: "Дата устранения дефекта",
    dataIndex: "dateTimeEnable",
    key: "dateTimeEnable",
    className: "nowrap",
    render: (date: Date) => (date ? M(date).format(Constants.dateFormat) : ""),
    sortable: true,
    visible: true,
  },
  {
    title: "Тип сети",
    dataIndex: ["gridType", "title"],
    key: "gridType",
    sortable: true,
    visible: true,
  },
  {
    title: "Зданий в зоне отключения/ограничения",
    key: "buildingsHeader",
    children: [
      {
        title: "Всего",
        dataIndex: "overBuildings",
        key: "overBuildings",
        width: "100px",
        sortable: true,
        visible: true,
      },
      {
        title: "Жилых",
        dataIndex: "livingBuildings",
        key: "livingBuildings",
        width: "100px",
        sortable: true,
        visible: true,
      },
      {
        title: "Лечебных",
        dataIndex: "hospitalBuildings",
        key: "hospitalBuildings",
        width: "100px",
        sortable: true,
        visible: true,
      },
      {
        title: "Детских",
        dataIndex: "childrenBuildings",
        key: "childrenBuildings",
        width: "100px",
        sortable: true,
        visible: true,
      },
    ],
    visible: true,
  },
  {
    title: "Диаметр трубы (Ду), мм",
    dataIndex: "diameter",
    key: "diameter",
    width: "100px",
    sortable: true,
    visible: true,
  },
  {
    title: "Признак выгрузки в МКА ЖКХ",
    dataIndex: ["mkaStatus", "title"],
    key: "mkaStatus",
    sortable: true,
    visible: true,
  },
  {
    title: "Признак СМИ",
    dataIndex: "mediaCoverage",
    key: "mediaCoverage",
    render: (mediaCoverage) => {
      return mediaCoverage ? "Да" : "Нет";
    },
    sortable: true,
    visible: true,
  },
  {
    title: "Комментарий СМИ",
    dataIndex: "mediaComment",
    key: "mediaComment",
    sortable: true,
    visible: false,
  },
  {
    title: "Нарушен срок устранения",
    dataIndex: "deadlineViolated",
    key: "deadlineViolated",
    render: (deadlineViolated) => {
      return deadlineViolated ? "Да" : "Нет";
    },
    // sortable: true,
    visible: true,
  },
];

const COLS_RSO = [
  {
    title: "№ п/п",
    dataIndex: "id",
    key: "id",
    width: "100px",
    sortable: true,
    fixed: true,
    visible: true,
  },
  {
    title: "ID дефекта",
    dataIndex: "externalId",
    key: "externalId",
    sortable: true,
    visible: true,
  },
  {
    title: "GUID",
    dataIndex: "uniqueIdentifier",
    key: "uniqueIdentifier",
    render: (uniqueIdentifier) => {
      return uniqueIdentifier ? uniqueIdentifier : "-";
    },
    sortable: true,
    visible: false,
  },
  {
    title: "Статус",
    dataIndex: ["incidentStatus", "title"],
    key: "incidentStatus",
    sortable: true,
    visible: true,
  },
  {
    title: "Адрес дефекта",
    dataIndex: "addressText",
    key: "addressText",
    className: "align-left",
    sortable: true,
    visible: true,
  },
  {
    title: "Дата отключения/ограничения",
    dataIndex: "dateTimeDisable",
    key: "dateTimeDisable",
    className: "nowrap",
    render: (date: Date) =>
      date ? M(date).format(Constants.dateFormat) : Constants.notSet,
    sortable: true,
    visible: true,
  },
  {
    title: "Дата устранения дефекта",
    dataIndex: "dateTimeEnable",
    key: "dateTimeEnable",
    className: "nowrap",
    render: (date: Date) => (date ? M(date).format(Constants.dateFormat) : ""),
    sortable: true,
    visible: true,
  },
  {
    title: "Зданий в зоне отключения/ограничения",
    key: "buildingsHeader",
    children: [
      {
        title: "Всего",
        dataIndex: "overBuildings",
        key: "overBuildings",
        width: "100px",
        sortable: true,
        visible: true,
      },
      {
        title: "Жилых",
        dataIndex: "livingBuildings",
        key: "livingBuildings",
        width: "100px",
        sortable: true,
        visible: true,
      },
      {
        title: "Лечебных",
        dataIndex: "hospitalBuildings",
        key: "hospitalBuildings",
        width: "100px",
        sortable: true,
        visible: true,
      },
      {
        title: "Детских",
        dataIndex: "childrenBuildings",
        key: "childrenBuildings",
        width: "100px",
        sortable: true,
        visible: true,
      },
    ],
    visible: true,
  },
  {
    title: "Диаметр трубы (Ду), мм",
    dataIndex: "diameter",
    key: "diameter",
    width: "100px",
    sortable: true,
    visible: true,
  },
  {
    title: "Признак выгрузки в МКА ЖКХ",
    dataIndex: ["mkaStatus", "title"],
    key: "mkaStatus",
    sortable: true,
    visible: true,
  },
  {
    title: "Нарушен срок устранения",
    dataIndex: "deadlineViolated",
    key: "deadlineViolated",
    render: (deadlineViolated) => {
      return deadlineViolated ? "Да" : "Нет";
    },
    // sortable: true,
    visible: true,
  },
];

const plannedColumns = new DefectTableFields(DEFAULT_DEFECT_COLS, true);
const nonPlannedColumns = new DefectTableFields(DEFAULT_DEFECT_COLS);

const DefectValidator: FC<DefectValidatorProps> = observer(() => {
  const { activeTab, setActiveTab, defectRemoveStatus } = defectCardsStore;
  const { isGrbs } = authStore;
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const openDefectCard = (key: string) => {
    if (!key) return;
    if (defectCardsStore?.cards?.length) {
      const card = defectCardsStore.cards.find(
        (card) => card.key.replace(/[P,D]/, "") === `${key}`,
      );
      if (card) {
        setActiveTab(card.key);
        // if (+id !== +key) {
        //   history.replace(`/sp/reestr/${key}`);
        // }
        return;
      }
    }
    defectCardsStore.addCard(key);
  };

  useStatusMessage(defectRemoveStatus);

  const [openAllDefectColsSetting, toggleOpenAllDefectColsSetting] =
    useState(false);
  const [openPlannedDefectColsSetting, toggleOpenPlannedDefectColsSetting] =
    useState(false);

  const settingsTapPane = (
    <div className="settings-tab-button">
      <SettingsIco />
      <DropDownWithoutSpaceIco />
    </div>
  );

  const initialTabs: Array<ITab> = [
    {
      name: settingsTapPane,
      key: SETTINGS_DEFECT_KEY,
      closable: false,
      content: "",
    },
    {
      name: "Реестр дефектов",
      key: REGISTER_DEFECTS,
      closable: false,
      content: (
        <AllDefectData
          columns={nonPlannedColumns}
          openDefectCard={openDefectCard}
        />
      ),
      store: allDefectDataStore,
    },
    {
      name: "Согласованные дефекты",
      key: CONSISTENT_DEFECTS,
      closable: false,
      content: (
        <AgreementDefectData
          columns={nonPlannedColumns}
          openDefectCard={openDefectCard}
        />
      ),
      store: agreementDefectDataStore,
    },
  ];

  const initialTabsPlan: Array<ITab> = [
    {
      name: settingsTapPane,
      key: SETTINGS_PLAN_KEY,
      closable: false,
      content: "",
    },
    {
      name: "Реестр плановых",
      key: REGISTER_PLANNED,
      closable: false,
      content: (
        <PlannedDefectData
          columns={plannedColumns}
          openDefectCard={openDefectCard}
        />
      ),
      store: plannedDefectDataStore,
    },
    {
      name: "Согласованные плановые",
      key: AGREED_PLANNED,
      closable: false,
      content: (
        <AgreementPlanedDefectData
          columns={plannedColumns}
          openDefectCard={openDefectCard}
        />
      ),
      store: agreementPlanedDefectDataStore,
    },
  ];

  const initialTabsRso: Array<ITab> = [
    {
      name: settingsTapPane,
      key: SETTINGS_DEFECT_KEY,
      closable: false,
      content: "",
    },
    {
      name: "Реестр дефектов",
      key: REGISTER_DEFECTS,
      closable: false,
      content: (
        <AllDefectData
          columns={nonPlannedColumns}
          openDefectCard={openDefectCard}
        />
      ),
      store: allDefectDataStore,
    },
    {
      name: "Согласованные дефекты",
      key: CONSISTENT_DEFECTS,
      closable: false,
      content: (
        <AgreementDefectData
          columns={nonPlannedColumns}
          openDefectCard={openDefectCard}
        />
      ),
      store: agreementDefectDataStore,
    },    
  ];

  const initialTabsPlanRso: Array<ITab> = [
    {
      name: settingsTapPane,
      key: SETTINGS_PLAN_KEY,
      closable: false,
      content: "",
    },
    {
      name: "Реестр плановых",
      key: REGISTER_PLANNED,
      closable: false,
      content: (
        <PlannedDefectData
          columns={plannedColumns}
          openDefectCard={openDefectCard}
        />
      ),
      store: plannedDefectDataStore,
    },
    {
      name: "Согласованные плановые",
      key: AGREED_PLANNED,
      closable: false,
      content: (
        <AgreementPlanedDefectData
          columns={plannedColumns}
          openDefectCard={openDefectCard}
        />
      ),
      store: agreementPlanedDefectDataStore,
    },    
  ];

  useEffect(() => {
    if (!activeTab) {
      setActiveTab(REGISTER_DEFECTS);
    }
  }, [activeTab]);
  useEffect(() => {
    if (id) {
      openDefectCard(id);
    }
  }, [id]);

  const defectCards: Array<ITab> = defectCardsStore.nonPlannedCards.map(
    (card) => {
      return {
        ...card,
        content: <DefectCard card={card} />,
        closeIcon: <CloseMediumIco />,
      };
    },
  );
  const defectPlannedCards: Array<ITab> = defectCardsStore.plannedCards.map(
    (card) => {
      return {
        ...card,
        content: <DefectCard card={card} />,
        closeIcon: <CloseMediumIco />,
      };
    },
  );

  const onTabChange = (key: string) => {
    if (key === SETTINGS_DEFECT_KEY || key === SETTINGS_PLAN_KEY) {
      return false;
    }

    const isNoCardTab = [
      REGISTER_DEFECTS,
      REGISTER_PLANNED,
      CONSISTENT_DEFECTS,
      AGREED_PLANNED,
    ].includes(key);

    if (defectCardsStore?.cards?.length && !isNoCardTab) {
      const card = defectCardsStore.cards.find((card) => card.key === key);
      if (card) {
        setActiveTab(card.key);
        const idKey = key.replace(/[P,D]/, "");
        // if (+id !== +idKey) {
        //   history.replace(`/sp/reestr/${idKey}`);
        // }
        return;
      }
    }
    if (id) {
      history.replace(`/sp/reestr/`);
    }
    setActiveTab(key);
  };

  const onEdit = (targetKey: string, action: "add" | "remove") => {
    if (action === "remove") {
      defectCardsStore.removeCard(targetKey);
    }
  };

  useEffect(() => {
    return () => {
      // Сброс до дефолтного набора колонок
      plannedColumns.initializeColumns(isGrbs ? DEFAULT_DEFECT_COLS : COLS_RSO);
      nonPlannedColumns.initializeColumns(
        isGrbs ? DEFAULT_DEFECT_COLS : COLS_RSO,
      );
    };
  }, []);

  useEffect(() => {
    plannedColumns.initializeColumns(isGrbs ? DEFAULT_DEFECT_COLS : COLS_RSO);
    nonPlannedColumns.initializeColumns(
      isGrbs ? DEFAULT_DEFECT_COLS : COLS_RSO,
    );
    loadTablesCols();
  }, [isGrbs]);

  const loadTablesCols = async () => {
    let allDefectTableCols = await userSettingsStore.loadSetting(
      "allDefectTableCols",
    );
    if (allDefectTableCols) {
      allDefectTableCols = allDefectTableCols.filter((col) => col);
      nonPlannedColumns.visibleCols.setKeys(allDefectTableCols);
      nonPlannedColumns.tempVisibleCols.setKeys(allDefectTableCols);
    }

    let plannedDefectTableCols = await userSettingsStore.loadSetting(
      "plannedDefectTableCols",
    );
    if (plannedDefectTableCols) {
      plannedDefectTableCols = plannedDefectTableCols.filter((col) => col);
      plannedColumns.visibleCols.setKeys(plannedDefectTableCols);
      plannedColumns.tempVisibleCols.setKeys(plannedDefectTableCols);
    }
  };

  const applyAllCols = () => {
    nonPlannedColumns.visibleCols.setKeys([
      ...nonPlannedColumns.tempVisibleCols.keys,
    ]);
    toggleOpenAllDefectColsSetting((prev) => !prev);
    userSettingsStore.saveSetting(
      "allDefectTableCols",
      JSON.stringify(nonPlannedColumns.visibleCols.keys),
    );
  };

  const applyPlannedCols = () => {
    plannedColumns.visibleCols.setKeys([
      ...plannedColumns.tempVisibleCols.keys,
    ]);
    toggleOpenPlannedDefectColsSetting((prev) => !prev);
    userSettingsStore.saveSetting(
      "plannedDefectTableCols",
      JSON.stringify(plannedColumns.visibleCols.keys),
    );
  };

  const onTabClick = (key) => {
    if (key === SETTINGS_DEFECT_KEY) {
      toggleOpenAllDefectColsSetting((prev) => !prev);
    }
    if (key === SETTINGS_PLAN_KEY) {
      toggleOpenPlannedDefectColsSetting((prev) => !prev);
    }
  };

  const renderCheckboxes = (field, context) => {
    let indeterminate = false;
    let children = [];
    if (field.children?.length > 0) {
      children = field.children.map((_field) =>
        renderCheckboxes(_field, context),
      );
    }
    const countOfChecked = context.tempVisibleCols.keys.filter((key) =>
      field.children?.map((child) => child.key).includes(key),
    ).length;
    const hasCheckedChildren =
      countOfChecked <= field.children?.length && countOfChecked > 0;
    indeterminate =
      countOfChecked < field.children?.length && countOfChecked > 0;

    if (
      field.children?.length > 0 &&
      hasCheckedChildren &&
      !context.tempVisibleCols.keys.includes(field.key)
    ) {
      context.tempVisibleCols.add(field.key);
    } else if (
      field.children?.length > 0 &&
      !hasCheckedChildren &&
      context.tempVisibleCols.keys.includes(field.key)
    ) {
      context.tempVisibleCols.remove(field.key);
    }
    return [
      <li className={styles["defect__checkbox-item"]} key={field.key}>
        <ICheckbox
          checked={context.tempVisibleCols.keys.includes(field.key)}
          label={field.title}
          disabled={field.fixed}
          indeterminate={indeterminate}
          onChange={() => {
            if (context.tempVisibleCols.keys.includes(field.key)) {
              if (field.children?.length > 0) {
                field.children.forEach((child) => {
                  context.tempVisibleCols.remove(child.key);
                });
              }
              context.tempVisibleCols.remove(field.key);
            } else {
              context.tempVisibleCols.add(field.key);
              if (field.children?.length > 0) {
                field.children.forEach((child) => {
                  context.tempVisibleCols.add(child.key);
                });
              }
            }
          }}
        />
      </li>,
      ...children,
    ];
  };
  const activeStore = (
    isGrbs
      ? [...initialTabs, ...initialTabsPlan]
      : [...initialTabsRso, ...initialTabsPlanRso]
  ).find((tab) => tab.key === activeTab)?.store;

  return (
    <div className={styles.Defect}>
      <DefectFilter />
      <ITabs
        activeKey={activeTab}
        onTabClick={onTabClick}
        onChange={onTabChange}
        onEdit={onEdit}
        tabs={
          isGrbs
            ? [
                ...initialTabs,
                ...defectCards,
                ...initialTabsPlan,
                ...defectPlannedCards,
              ]
            : [
                ...initialTabsRso,
                ...defectCards,
                ...initialTabsPlanRso,
                ...defectPlannedCards,
              ]
        }
        tabBarExtraContent={<DefectActions targetStore={activeStore} />}
        editable
        hideAdd
      />
      <DefectNotifyPopup />
      <DefectTableSettingsForm />
      {openAllDefectColsSetting && (
        <DraggableModal
          visible={openAllDefectColsSetting}
          defaultPosition={{ x: 151, y: 0 }}
          title={"Настройка видимости столбцов для реестра дефектов"}
          footer={<IButton onClick={applyAllCols}>Добавить столбцы</IButton>}
          onCancel={() => toggleOpenAllDefectColsSetting((prev) => !prev)}
        >
          <ul>
            <li className={styles["defect__checkbox-item"]}>
              <ICheckbox
                checked={nonPlannedColumns.isSelectedAll}
                label="Выбрать все"
                onChange={() => {
                  if (nonPlannedColumns.isSelectedAll) {
                    nonPlannedColumns.tempVisibleCols.setKeys([
                      ...nonPlannedColumns.fixedColumnsKeys,
                    ]);
                  } else {
                    nonPlannedColumns.tempVisibleCols.setKeys([
                      ...nonPlannedColumns.allColumnsKeys,
                    ]);
                  }
                }}
              />
            </li>
            {nonPlannedColumns.columns.map((field) =>
              renderCheckboxes(field, nonPlannedColumns),
            )}
          </ul>
        </DraggableModal>
      )}
      {openPlannedDefectColsSetting && (
        <DraggableModal
          visible={openPlannedDefectColsSetting}
          defaultPosition={{ x: 530, y: 0 }}
          title={"Настройка видимости столбцов для реестра плановых"}
          footer={
            <IButton onClick={applyPlannedCols}>Добавить столбцы</IButton>
          }
          onCancel={() => toggleOpenPlannedDefectColsSetting((prev) => !prev)}
        >
          <ul>
            <li className={styles["defect__checkbox-item"]}>
              <ICheckbox
                checked={plannedColumns.isSelectedAll}
                label="Выбрать все"
                onChange={() => {
                  if (plannedColumns.isSelectedAll) {
                    plannedColumns.tempVisibleCols.setKeys([
                      ...plannedColumns.fixedColumnsKeys,
                    ]);
                  } else {
                    plannedColumns.tempVisibleCols.setKeys([
                      ...plannedColumns.allColumnsKeys,
                    ]);
                  }
                }}
              />
            </li>
            {plannedColumns.columns.map((field) =>
              renderCheckboxes(field, plannedColumns),
            )}
          </ul>
        </DraggableModal>
      )}
    </div>
  );
});

export default DefectValidator;
